var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lucide/file-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.33268 1.33325V3.99992C9.33268 4.35354 9.47316 4.69268 9.72321 4.94273C9.97326 5.19278 10.3124 5.33325 10.666 5.33325H13.3327M7.99935 11.9999V7.99992M7.99935 11.9999L5.99935 9.99992M7.99935 11.9999L9.99935 9.99992M9.99935 1.33325H3.99935C3.64573 1.33325 3.30659 1.47373 3.05654 1.72378C2.80649 1.97382 2.66602 2.31296 2.66602 2.66659V13.3333C2.66602 13.6869 2.80649 14.026 3.05654 14.2761C3.30659 14.5261 3.64573 14.6666 3.99935 14.6666H11.9993C12.353 14.6666 12.6921 14.5261 12.9422 14.2761C13.1922 14.026 13.3327 13.6869 13.3327 13.3333V4.66659L9.99935 1.33325Z",
    stroke: "#37397C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFileIcon);
export default __webpack_public_path__ + "static/media/download-file-icon.aac60d29ed01b8198b46d90c67295c66.svg";
export { ForwardRef as ReactComponent };